import React, { memo, useCallback, useMemo, useEffect, useState } from 'react'
import { connect } from 'react-redux'

import { generateStateKey } from '../../../../../../utilities/generateStateKey'
import { cl } from '../../../../../../utilities/cl'

import Collapsible from '../../../../../../components/Space/Collapsible'
import ScrollContainer from '../../../../../../components/ScrollContainer'
import List from '../../../../../../components/List'
import SvgArrowUpDown from '../../../../../../components/SVG/ArrowUpDown'
import SvgPlay from '../../../../../../components/SVG/Play'
import SvgPause from '../../../../../../components/SVG/Pause'
import { formatSecondsToTime } from '../../../../../../utilities/format'
import { store } from '../../../../../../connect'


const Song = ({
    id,
    name,
    cliptime,
    tempo,
    genre_name,
    year,
    isSelected,
    isMarkItems,
    variant,
    isPlaying,
    play,
    pause,
    rewind,
    filename,
    audio,
    className
}) => {


    const duration = useMemo(() => {
        return cliptime?.split?.(":").splice(1).join(":").split('.')?.[0] || ''
    }, [])
    const [slider, setSlider] = useState();
    const [currentWatcherInterval, setCurrentWatcherInterval] = useState(null);

    useEffect(() => {
        if (isPlaying) {
            startWatch();
        } else {
            killWatcher();
        }

        return () => killWatcher();
    }, [isPlaying, audio]);


    function startWatch() {
        killWatcher(); // Сначала очищаем предыдущий интервал

        if (isPlaying && audio) {
            const interval = setInterval(() => {
                if (isPlaying) {
                    updateTime();
                }
            }, 50);
            setCurrentWatcherInterval(interval);
        }
    }

    function killWatcher(resetTime) {
        if (currentWatcherInterval) {
            clearInterval(currentWatcherInterval);
            setCurrentWatcherInterval(null);
        }
        updateTime(resetTime);
    }


    const updateTime = (resetTime) => {
        let currentTime = "00:00"


        if (resetTime !== true && (audio.current?.currentTime !== audio.current?.duration && isPlaying)) {
            // Время
            currentTime = formatSecondsToTime(audio.current?.currentTime)

            // Слайдер

            const sliderPercent = (audio.current?.currentTime / (audio.current?.duration / 100))
            setSlider(sliderPercent)
        }

    }

    const rewinds = (e) => {
        const rect = e.target.getBoundingClientRect()
        const clickPercent = 100 * (e.nativeEvent.offsetX / rect.width)
        const totime = clickPercent * 0.01
        console.log({ totime, audio });
        audio.current.currentTime = audio.current.duration * totime


    }
    const plays = useCallback(() => {
        pause()
        play({
            trackId: id,
            filename,
            name,
            duration
        })
    }, [id, filename, name, duration, pause, play])

    const pauses = useCallback(() => pause(), [pause])




    className = cl(
        className,
        // { "Playlist": [variant] },
        "selectable-item",
        { "Song": [variant] },
        { "selected": isSelected },
        { "highlighted": isMarkItems },
        { "playing": isPlaying },
        { "name-fade": slider === 100 },
    )



    return (
        <div className={className} data-song-id={id} >
            <header className="Song__header">
                <span className="rewind" onClick={rewinds} data-playing={isPlaying}></span>
                {slider > 0 && (
                    <>
                        <span className="slider-1" style={{ right: `${100 - slider}%` }}></span>
                        <span className="slider-2" style={{ right: `${100 - slider}%` }}></span>
                    </>
                )}

                <div className="Songs__grid">
                    <div className="id" data-song-id={id}>{id}</div>
                    <div className="play">
                        {isPlaying ? (
                            <span onClick={pauses}>
                                <SvgPause className="icon-pause" variant="prim" size="xs1" title="Приостановить" />
                            </span>
                        ) : (
                            <span onClick={plays}>
                                <SvgPlay className="icon-play" variant="prim" size="xs1" title="Воспроизвести" />
                            </span>
                        )}
                    </div>
                    <div className="composition" data-song-id={id}>
                        <h4 title={name}>{name.length > 36 ? `${name.substr(0, 37)}...` : name}</h4>
                    </div>
                    <div className="duration" data-song-id={id}>{duration}</div>
                    <div className="temp" data-song-id={id}>{tempo}</div>
                    <div className="chill_out" data-song-id={id}>{genre_name}</div>
                    <div className="added" data-song-id={id}>{year}</div>
                </div>
            </header>
        </div>
    )
}

export default Song